import type { AppThemeConfig } from "@src/interfaces/theme-config.interface";

/**
 * Springfield Behavioral of Pennsylvania theme overrides layered on top of the Optum baseline.
 *
 * Keep this config as deltas only; any token or asset omitted here
 * inherits from the default Optum theme.
 */
export const SPRINGBHPENN_THEME_CONFIG: AppThemeConfig = {
  theme: {
    colors: {},
  },
  assets: {
    header: {
      title: {
        hidden: true,
      },
      logo: {
        src: "/themes/springbhpenn/logo.png",
        alt: "Springfield Behavioral of Pennsylvania Logo",
        style: { width: "200px", height: "100%", isMobile: { width: "150px" } },
      },
    },
    icons: {},
  },
  providerGroupId: 33,
  state: "PA",
  departmentIds: [129, 138, 141, 144, 155, 166, 169, 174, 175],
};
